import { Box, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import bn_1 from "./images/bn_1.png";
import bn_2 from "./images/bn_2.jpg";
import bn_3 from "./images/bn_3.png";
import bn_4 from "./images/bn_4.png";
import bn_5 from "./images/bn_5.jpg";
// import college1 from "./images/au_ad.jpg";
// import college1 from "./images/au_ad.jpg";
// import college1 from "./images/au_ad.jpg";
// import college1 from "./images/au_ad.jpg";
// import college2 from "./images/inter_clg.png";
// import college3 from "./images/college3.jpg";

const BannerComponent = () => {
  const [image, setImage] = useState([]);

  const data = {
    imagelist: [bn_1,bn_2,bn_3,bn_4, bn_5],
  };

  const setUnitvalue = () => {
    setImage(data["imagelist"]);
  };

  useEffect(() => {
    setUnitvalue();
  }, []);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

const [isPaused, setIsPaused] = useState(false);

const carouselSettings = {
  autoPlay: !isPaused,
  autoPlaySpeed: 2000,
  infinite: true,
  transitionDuration: 800,
  removeArrowOnDeviceType: ["tablet", "mobile"],
  showDots: true,
  pauseOnHover: true,
  draggable: true,
  swipeable: true,
  pauseOnSwipe: true,
};

  return (
  <>
    {image.length === 0 ? (
      <CircularProgress />
    ) : (
      <Carousel
        {...carouselSettings}
        responsive={responsive}
      >
        {image.map((imageUrl, index) => (
          <Box
  key={index}
  sx={{ width: "100%", display: "flex", justifyContent: "center" }}
  onMouseEnter={() => setIsPaused(true)}
  onMouseLeave={() => setIsPaused(false)}
  onTouchStart={() => setIsPaused(true)}
  onTouchEnd={() => setIsPaused(false)}
  onTouchCancel={() => setIsPaused(false)}
>
  <Box
    component="img"
    src={imageUrl}
    alt={`Banner ${index + 1}`}
    loading="lazy"
    sx={{
      width: "100%",
      height: { xs: "40vh", sm: "50vh", md: "auto" },
      maxHeight: "70vh",
      objectFit: "cover",
      borderRadius: { xs: "0 0 32px 32px", sm: "0 0 32px 32px", md: "0" },
      overflow: "hidden",
    }}
  />
</Box>

        ))}
      </Carousel>
    )}
  </>
);


  // return (
  //   <>
  //     {image.length === 0 ? (
  //       <CircularProgress />
  //     ) : (
  //       <Carousel
  //         {...carouselSettings}
  //         animation="slide"
  //         indicators={false}
  //         responsive={responsive}
  //       >
  //         {image.map((imageUrl, index) => (
  //           <Box
  //             key={index}
  //             // sx={{
  //             //   backgroundImage: `url(${imageUrl})`,
  //             //   backgroundRepeat: "no-repeat",
  //             //   backgroundColor: "black",
  //             //   backgroundPosition: "center",
  //             //   backgroundSize: "cover",
  //             //   height: "100vh",
  //             //   width: "100%",
  //             //   justifyContent: "center",
  //             //   position: "relative",
  //             // }}
  //           >
  //             <img
  //               key={index}
  //               // sx={
  //               //     {
  //               //     // backgroundImage: `url(${imageUrl})`,
  //               //     backgroundRepeat: "no-repeat",
  //               //     backgroundColor: "black",
  //               //     backgroundPosition: "center",
  //               //     backgroundSize: "cover",
  //               //     height: "100vh",
  //               //     width: "100%",
  //               //     justifyContent: "center",
  //               //     position: "relative",
  //               //   }
  //               // }
  //               style={{
  //                 backgroundRepeat: "no-repeat",
  //                 // backgroundColor: "black",
  //                 backgroundPosition: "center",
  //                 backgroundSize: "cover",
  //                 height: "65vh",
  //                 width: "100%",
  //                 justifyContent: "center",
  //                 position: "relative",
  //               }}
  //               // height="100vh"
  //               // width="100%"
  //               src={imageUrl}
  //               alt="Image Alt"
  //               loading="lazy"
  //               placeholder="./assets/au_logo.png"
  //             />
  //             {/* <iframe src="iframe" loading="lazy"></iframe> */}
  //             {/* <Box
  //               sx={{
  //                 position: "absolute",
  //                 top: "50%",
  //                 left: "50%",
  //                 transform: "translate(-50%, -50%)",
  //                 textAlign: "center",
  //                 backdropFilter: "blur(2px)",
  //                 padding: "2rem",
  //               }}
  //             >
  //               <div className="rbt-new-badge rbt-new-badge-one mb--30">
  //                 <span className="rbt-new-badge-icon">🏆</span>
  //                 The Leader in jharkhand
  //               </div>
  //               <h1 className="title">
  //                 We teach, educate and{" "}
  //                 <span className="theme-gradient">build the future</span> of
  //                 learners
  //               </h1>
  //             </Box> */}
  //           </Box>
  //         ))}
  //       </Carousel>
  //     )}
  //   </>
  // );
};

export default BannerComponent;
